import React from 'react';
import { ZapIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-28 md:py-36 relative overflow-hidden bg-teal-50/50 border-t border-slate-200" data-id="element-13" data-mp="27gdt6e98cqol">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10 text-center" data-id="element-14" data-mp="2cg08qucj6j0k">
        <h2 className="text-4xl md:text-5xl font-medium text-slate-900 tracking-tight mb-6 text-balance" data-id="element-15" data-mp="2hejtwsjavqrv">
          Stop updating HubSpot by hand.
        </h2>
        <p className="text-lg md:text-xl text-slate-600 mb-10 max-w-2xl mx-auto font-normal" data-id="element-16" data-mp="2mdo2bgyehkh5">
          Kinase pulls qualification data and next steps from your Zoom
          recordings and writes them to HubSpot. Your reps never touch the CRM.
        </p>

        <div className="flex items-center justify-center" data-id="element-17" data-mp="305kpd6l7p46o">
          <a href="https://app.getkinase.com" className="px-6 py-3 bg-teal-500 hover:bg-teal-400 text-white rounded-lg font-medium text-base transition-colors flex items-center justify-center space-x-2 shadow-sm shadow-teal-500/20" data-id="element-18" data-mp="3075m92v00z7p">
            <ZapIcon className="w-4 h-4" data-id="element-19" data-mp="217tag5o2dbmy" />
            <span data-id="element-20" data-mp="1w759osa19gfj">Request free early access</span>
          </a>
        </div>
      </div>
    </section>;
}